export default __webpack_public_path__ + "static/media/HTML.ea5873c0.jpg";